import { currentTimeMillis, exists, Module, MUSTNeverHappenException } from '@nu-art/ts-common';
import { APIDef_AvatarMode } from '@app/advisor-ui-shared';
import { apiWithQuery } from '@nu-art/thunderstorm-frontend/index';
import { jwtDecode } from 'jwt-decode';
import { PermissionKey_FE } from '@nu-art/permissions-frontend';
import { PermissionKeys_Avatar } from '@app/advisor-ui-shared/permissions/avatar-ui';
class ModuleFE_AvatarMode_Class extends Module {
    _v1;
    permissions;
    constructor() {
        super();
        this._v1 = {
            getAllEncounters: apiWithQuery(APIDef_AvatarMode.getAllEncounters),
            getAvatarLaunchJwt: apiWithQuery(APIDef_AvatarMode.getAvatarLaunchJwt),
        };
        this.permissions = PermissionKey_FE.generatePermissionKeysByLevels(PermissionKeys_Avatar);
        this.logWarning(this.permissions.Release);
    }
    decodeAvatarSession = (session) => {
        try {
            return jwtDecode(session);
        }
        catch (e) {
            this.logError('Failed to decode session', e);
            throw new MUSTNeverHappenException('cannot decode session', e);
        }
    };
}
export const ModuleFE_AvatarMode = new ModuleFE_AvatarMode_Class();
export const JWT = {
    decode: (jwt) => {
        try {
            return jwtDecode(jwt);
        }
        catch (e) {
            throw new MUSTNeverHappenException('cannot decode session', e);
        }
    },
    isValid: (jwt) => {
        try {
            if (!jwt)
                return false;
            // Decode the JWT token to access its payload.
            // Here we expect an optional 'exp' claim (expiration time in seconds).
            const decodedJWT = jwtDecode(jwt);
            // If the expiration time is not present, consider the session invalid.
            if (!exists(decodedJWT.exp))
                return false;
            // Get the current time in seconds.
            const currentTime = currentTimeMillis() / 1000;
            // Return true if the token's expiration time is in the future.
            return decodedJWT.exp > currentTime;
        }
        catch (error) {
            // Log any errors during decoding and consider the session invalid.
            return false;
        }
    }
};
//# sourceMappingURL=ModuleFE_AvatarMode.js.map